import React from 'react';
import ConfigurableItem from './configurable-item';

const Configurable = ({
  current_option,
  configurable_options,
  onChangeConfigurableProduct,
}) => {
  const changeOptionHandler = (option) => {
    onChangeConfigurableProduct({ current_option, ...option });
  };

  return (
    <div className='my-2 flex flex-col gap-4'>
      {configurable_options?.length > 0 &&
        configurable_options?.map((config, i) => (
          <ConfigurableItem
            key={i}
            title={config?.label}
            options={config?.options}
            currentOption={current_option}
            onChangeCurrentOption={changeOptionHandler}
          />
        ))}
    </div>
  );
};

export default Configurable;
